// Centralized route path constants. Every <Route path=...> and every <Link to=.../navigate() call
// in the app should reference ROUTES rather than a string literal, so a path can be renamed in one
// place without hunting through the component tree.
export const ROUTES = {
  HOME: '/',
  EXAMPLE: '/example',
  NOTFOUND: '/404',
}
